import React from "react";

const Resolutions = () => {
  return <div></div>;
};

export default Resolutions;
